import * as React from "react";
import { cn } from "@/lib/utils";
import { Button } from "./button";
import { TriangleAlertIcon } from "lucide-react";

const InputSideLabel = React.forwardRef<
	HTMLButtonElement,
	React.ComponentProps<"button">
>(({ className, children, ...props }, ref) => {
	return (
		<Button
			variant="secondary"
			ref={ref}
			size="sm"
			className={cn("absolute h-full right-0 rounded-l-none border", className)}
			{...props}
		>
			{children}
		</Button>
	);
});

InputSideLabel.displayName = "InputSideLabel";

type InputSideLabelPopoverProps = React.ComponentProps<"div"> & {
	title: string;
	content: string;
	error: string | null;
	isAltered: boolean;
	resetParam: () => void;
};

const InputSideLabelPopover = React.forwardRef<
	HTMLDivElement,
	InputSideLabelPopoverProps
>(
	(
		{ className, title, content, error, isAltered, resetParam, ...props },
		ref
	) => {
		return (
			<div
				ref={ref}
				className={cn("flex flex-col gap-2", className)}
				{...props}
			>
				<h3 className="font-semibold">{title}</h3>
				<p>{content}</p>
				{!!error && (
					<p className="text-sm inline-flex items-start gap-2 text-destructive">
						<TriangleAlertIcon />
						{error}
					</p>
				)}

				{isAltered && (
					<div className="flex justify-end">
						<Button
							onClick={resetParam}
							size="sm"
							className="bg-orange-400 hover:bg-orange-500 h-8"
						>
							Tilbakestill
						</Button>
					</div>
				)}
			</div>
		);
	}
);

export { InputSideLabel, InputSideLabelPopover };
